<template>
	<div class="data19">
		<div class="data19TilBox">
			<div class="data19Til">人性化设计·操控升级焕新</div>
		</div>
		<div>
			<div class="swiper-hexinTwo">
				<div class="swiper-wrapper">
					<div class="swiper-slide swiper-slideTwo" v-for="(itema,indexa) in list" :key="indexa">
						<div class="swiper-slideTwo-img">
							<img :src="itema.img" />
						</div>
						<div class="swiper-slideTwo-name">
							{{itema.name}}
						</div>
						<div class="swiper-slideTwo-cen">
							{{itema.cen}}
						</div>
					</div>
				</div>
				<div class="swiper-hexin-prev" :style="{
					display:prev
				}">
					<img src="@/assets/product/page6/zjt.png" />
				</div>
				<div class="swiper-hexin-next" :style="{
					display:next
				}">
					<img src="@/assets/product/page6/yjt.png" />
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				list: [{
						img: require("@/assets/content/hexinBanner.png"),
						name: '轻量手柄',
						cen: '- 依托轻量材质与人体工学设计，有效减少医生长期操作的疲劳度- 支持手柄按键自定义设置，方便医生日常使用'
					},
					{
						img: require("@/assets/content/hexinBanner.png"),
						name: '一体式全防水接头',
						cen: '- 一键插拔，减少内镜脱机的繁琐步骤- 无需额外防水盖便可整体浸泡洗消，洗消更便捷'
					},
					{
						img: require("@/assets/content/hexinBanner.png"),
						name: '同步传导',
						cen: '- 结肠镜插入部的惯性设计将手柄处操作者的推拉力和旋转力传递到结肠镜的先端部- 能够帮助医生更好地进镜到盲肠'
					},
					{
						img: require("@/assets/content/hexinBanner.png"),
						name: '软硬可调',
						cen: '- 结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度- 可满足结肠不同部位的进镜需求'
					},
					{
						img: require("@/assets/content/hexinBanner.png"),
						name: '随动弯曲',
						cen: '-顺应结肠不同部位的转向，在脾曲肝曲等部位自适应扭转镜身向空腔行进-'
					},
				],
				mySwiperTwo: '',
				mySwiper: "",
				innerSwipers: [],
				sliact: 0,
				prev: 'none',
				next: 'block'
			}
		},
		mounted() {
			let t = this;
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			this.mySwiper = new this.$swiper('.swiper-hexinTwo', {
				// 内部Swiper的选项
				direction: 'horizontal',
				widch: 580,
				slidesPerView: 2.3, // 每屏显示3个滑块
				slidesPerGroup: 1, // 每次滑动3个滑块
				spaceBetween: 40,
				slidesOffsetBefore: 250,
				slidesOffsetAfter: 250,
				// 自动播放
				autoplay: false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionEnd: function() {
						if (this.activeIndex === 0) {
							t.prev = 'none';
						} else {
							t.prev = 'block';
						}
						if (this.activeIndex === this.slides.length - 1) {
							t.next = 'none';
						} else {
							t.next = 'block';
						}
						if (this.activeIndex === this.slides.length - 2) {
							t.next = 'none';
						} else {
							t.next = 'block';
						}
						// if (t.sliact == this.activeIndex && t.sliact == this.slides.length - 2) {
						// 	t.next = 'none';
						// } else {
						// 	t.sliact = this.activeIndex;
						// }
					},
				},
			});


		},
		methods: {
			
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-hexin {
		overflow: hidden;
	}

	.swiper-hexinTwo {
		overflow: hidden;
		position: relative;

		.swiper-hexin-prev {
			position: absolute;
			top: 50%;
			left: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;

			img {
				width: 51px;
				height: 51px;
			}

			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;

		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 50%;
			right: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			border-radius: 100%;
			transition: all 0.3s ease;

			img {
				width: 51px;
				height: 51px;
			}
		}
	}

	.swiper-slideTwo {
		position: relative;

		// width: 580px;
		.swiper-slideTwo-img {
			// width: 580px;
			height: 440px;
			margin-bottom: 34px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.swiper-slideTwo-name {
			font-size: 26px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			margin-bottom: 32px;
		}

		.swiper-slideTwo-cen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
		}
	}

	.data19 {
		margin-bottom: 150px;

		.data19TilBox {
			width: 1200px;
			margin: 0 auto;
		}

		.data19Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 92px;
		}

		.data19Tab {
			position: relative;
			width: 800px;
			padding-bottom: 35px;
			display: flex;
			align-items: center;
			border-bottom: 2px solid #E5E5E5;
			margin-bottom: 56px;

			.data19TabFor:nth-of-type(1) {
				width: 60%;
			}

			.data19TabFor:nth-of-type(2) {
				width: 20%;
			}

			.data19TabFor:nth-of-type(3) {
				width: 20%;
			}

			.data19TabFor {
				font-size: 26px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #000000;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.data19TabXian {
				position: absolute;
				bottom: -1px;
				left: 0;
				width: 60%;
				height: 2px;
				background: #000000;
				transition: all .3s ease-in-out;
			}
		}
	}
</style>